import { get } from "react-hook-form";
import { GetQueryProps, UpdateAttributeTagInput } from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getMspId,
  getQueryDataObject,
} from "utilz/helpers";

export const getAttributeTags = async ({
  filter,
  pageNumber,
  perPageCount,
  searchQuery,
  sortColumn,
  sortDirection,
}: GetQueryProps) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });
    const url = await generateUrlString({
      baseUrl: `/configuration/fetch/tag/msp/${getMspId()}`,
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const addAttributetag = async (data: any) => {
  try {
    const url = `/configuration/create/tag/${getMspId()}`;
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateAttributetag = async ({
  tagId,
  data,
}: UpdateAttributeTagInput) => {
  try {
    const url = `/configuration/update/tag/${tagId}`;
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteAttributeTags = async (tagIds: string[]) => {
  try {
    const url = "/v2/configuration/tag";
    const response = await axiosClient.delete(`${url}`, {
      data: {
        tags: tagIds,
      },
    });
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
